export default __webpack_public_path__ + "static/media/a037-student-t3-s3-2.25d009a9.svg";